import { useEffect, useMemo, useState } from 'react';
import { STABLE_EMPTY_OBJECT } from '../../common/utils';
import { getUfoExperience } from './utils';
/**
 * This hook is responsible for fetching the module from it's remote address.
 * Note it won't reload if it is already in the registry.
 *
 * @param remoteFrontendSdk
 * @param options
 */
const useRemoteModuleLoader = (remoteFrontendSdk, options = STABLE_EMPTY_OBJECT) => {
  const [state, setStatus] = useState({
    status: remoteFrontendSdk.isModuleRegisteredAndValid() ? 'done' : 'initial'
  });
  const {
    status,
    error
  } = state;
  const {
    onError,
    onEvent
  } = options;
  const moduleName = remoteFrontendSdk.getModuleName();
  const experience = useMemo(() => getUfoExperience(moduleName, 'fetch'), [moduleName]);
  useEffect(() => {
    return () => {
      void experience.abort({
        metadata: {
          moduleName
        }
      });
    };
  }, [experience, moduleName]);
  useEffect(() => {
    if (status === 'error' && typeof onError === 'function') {
      onError(error);
    }
  }, [error, status, onError]);
  useEffect(() => {
    // we don't want to re-run the experience if the module is already in the registry and has been loaded
    if (status === 'initial') {
      void experience.start();
      setStatus({
        status: 'loading'
      });
      remoteFrontendSdk.fetchModule().then(() => {
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
          type: 'fetch-complete'
        });
        void experience.success({
          metadata: {
            moduleName
          }
        });
        setStatus({
          status: 'done'
        });
      }).catch(error => {
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
          type: 'fetch-error'
        });
        void experience.failure({
          metadata: {
            error,
            moduleName
          }
        });
        setStatus({
          error: error,
          status: 'error'
        });
      });
    }
  }, [status, remoteFrontendSdk, onError, experience, moduleName, onEvent]);
  return state;
};
export default useRemoteModuleLoader;